import {
  LOADING_PORTAL_CONFIG,
  SET_PORTAL_CONFIG,
  RESET_PORTAL_CONFIG,
  UPDATE_PORTAL_CONFIG,
} from "./actions";

const initialState = {
  loading: true,
  config: {},
};

const portalConfig = (state = initialState, { payload, type }) => {
  switch (type) {
    case LOADING_PORTAL_CONFIG:
      return {
        loading: true,
        config: {},
      };
    case SET_PORTAL_CONFIG:
      localStorage.setItem("portalConfig", JSON.stringify(payload));
      return {
        loading: false,
        config: payload,
      };
    case UPDATE_PORTAL_CONFIG:
      const updatedConfig = { ...state.config, ...payload };
      localStorage.setItem("portalConfig", JSON.stringify(updatedConfig));
      return {
        loading: false,
        config: updatedConfig,
      };
    case RESET_PORTAL_CONFIG:
      localStorage.removeItem("portalConfig");
      return {
        loading: false,
        config: {},
      };
    default:
      return state;
  }
};

export default portalConfig;
